import { styled } from "@mui/material/styles";
import { lighten } from "@mui/system";

export const CatHeader = styled("div")(({ theme }) => ({
  position: "sticky",
  top: "-8px",
  padding: "4px 10px",
  color: theme.palette.primary.main,
  backgroundColor: lighten(theme.palette.primary.light, 0.7),
}));

export const IndItems = styled("ul")({
  padding: 0,
});
